import type { MappingCoverageFilters } from './types'

import { queryOptions } from '@tanstack/react-query'
import { listMappingCoverageSignals } from './api'

export const mappingCoverageQueryKeys = {
  all: ['mapping-coverage'] as const,
  signals: (filters: MappingCoverageFilters = {}) => [...mappingCoverageQueryKeys.all, 'signals', filters] as const,
}

export function mappingCoverageSignalsQueryOptions(filters: MappingCoverageFilters = { limit: 50 }) {
  return queryOptions({
    queryKey: mappingCoverageQueryKeys.signals(filters),
    queryFn: () => listMappingCoverageSignals(filters),
  })
}
